import { makeVar } from '@apollo/client/cache';
import { CONSTANTS } from 'config/constants';
import Cookies from 'js-cookie';

const { TOKEN_KEY } = CONSTANTS;

export const isSignedInVar = makeVar<boolean>(!!Cookies.get(TOKEN_KEY));
export const userIdVar = makeVar<string>('');
